import { Link } from "react-router-dom";
import config from "../configs";
import images from "../constants/images";

const Footer = () => {
  return (
    <div className="footer">
      <Link to="/">
        <img src={images.logo} className="logo" />
      </Link>
      <div className="copyright">
        Copyright © {new Date().getFullYear()}, Created by{" "}
        {config.appName + " "}
        Team 
      </div>
      <div className="contact">
        <Link to="/contact">Contact Us</Link> |<Link to="/dmca">DMCA</Link>
        | <Link to="/about">About Us</Link>
      </div>
    </div>
  );
};

export default Footer;
